import { ReactNode, SVGProps, forwardRef } from 'react';

export type CustomIconProps = SVGProps<SVGSVGElement> & { size?: number };

interface CreateCustomIconConfig {
  displayName: string;
  children: ReactNode;
  viewBox?: string;
  defaultFill?: string;
}

export function createCustomIcon({
  displayName,
  children,
  viewBox = '0 0 24 24',
  defaultFill = 'none',
}: CreateCustomIconConfig) {
  const Icon = forwardRef<SVGSVGElement, CustomIconProps>(
    ({ size = 24, className, ...props }, ref) => (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox={viewBox}
        fill={defaultFill}
        className={`custom-icon${className ? ` ${className}` : ''}`}
        {...props}
      >
        {children}
      </svg>
    ),
  );

  Icon.displayName = displayName;
  return Icon;
}
